import React, { useEffect, useState } from 'react';
import { useLocation, useNavigate, useParams } from 'react-router-dom';
import axios from 'axios';
import { getApiUrl, getAuthHeaders, API_ENDPOINTS } from '../../../config/api.config';
import './SubmissionComplete.css';

const SubmissionComplete = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const { id } = useParams();

  const [data, setData] = useState(() => location.state || null);

  useEffect(() => {
    if (!data) {
      // fetch from server
      const fetchData = async () => {
        try {
          const res = await axios.get(getApiUrl(API_ENDPOINTS.SUBMISSION.GET(id)), { headers: getAuthHeaders() });
          if (res.data && res.data.status === 'success') {
            // transform to expected shape
            const submission = res.data.data;
            setData({
              scores: {},
              totalScore: submission.totalScore,
              answers: submission.submissions.reduce((acc,s)=>{acc[s.questionId]=s.answer;return acc;},{}),
              questions: submission.submissions.map(s=>({ _id: s.questionId, question: 'Question', marks: 0 }))
            });
          }
        } catch(err){
          console.error('Failed to fetch submission', err);
        }
      };
      fetchData();
    }
  }, [data,id]);

  if (!data) {
    return (
      <div className="submission-complete"><h1>Loading...</h1></div>
    );
  }

  const { scores = {}, totalScore = 0, answers = {}, questions = [] } = data;

  const maxPossibleScore = questions.reduce((total, q) => total + (q.marks || 0), 0);

  return (
    <div className="submission-complete">
      <h1>Submission Complete</h1>
      
      <div className="total-score-card">
        <h2>Overall Score</h2>
        <div className="score">
          {totalScore} / {maxPossibleScore}
        </div>
        <div className="percentage">
          {maxPossibleScore > 0 
            ? `${((totalScore / maxPossibleScore) * 100).toFixed(1)}%` 
            : '0%'}
        </div>
      </div>

      <div className="questions-breakdown">
        <h2>Detailed Breakdown</h2>
        {questions.map((question, index) => {
          const questionScore = scores[question._id] || { score: 0, feedback: 'No feedback available' };
          const studentAnswer = answers[question._id] || 'No answer provided';
          
          return (
            <div key={question._id || index} className="question-result">
              <h3>Question {index + 1}</h3>
              <div className="question-text">{question.question}</div>
              
              <div className="answer-section">
                <h4>Your Answer:</h4>
                <div className="answer-text">{studentAnswer}</div>
              </div>

              <div className="score-section">
                <div className="question-score">
                  Score: {questionScore.score} / {question.marks || 0}
                </div>
                <div className="feedback">
                  <h4>Feedback:</h4>
                  <p>{typeof questionScore.feedback === 'object' && questionScore.feedback 
                      ? (questionScore.feedback.aiComment || questionScore.feedback.suggestion || 'No feedback available')
                      : (questionScore.feedback || 'No feedback available')}</p>
                </div>
              </div>
            </div>
          );
        })}
      </div>

      <button 
        onClick={() => navigate('/dashboard')} 
        className="back-button"
      >
        Back to Dashboard
      </button>
    </div>
  );
};

export default SubmissionComplete; 